import { render, staticRenderFns } from "./knowledgeList.vue?vue&type=template&id=684fbab6&scoped=true"
import script from "./knowledgeList.vue?vue&type=script&lang=js"
export * from "./knowledgeList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeList.vue?vue&type=style&index=0&id=684fbab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fbab6",
  null
  
)

export default component.exports